<template>
  <div
    class="m-auto max-w-md rounded-lg bg-white px-6 text-left md:mb-4 md:rounded-md md:border md:border-light-gray md:px-14 md:py-10 md:shadow-primary lg:max-w-xl"
    :class="[marginUnderLogo ? 'pb-4 pt-3' : 'py-8', customClass]"
  >
    <div
      class="-mx-6 mb-6 flex justify-center border-b border-light-gray px-6 md:mx-0 md:mb-2 md:mt-0 md:border-0 md:px-0"
      :class="[marginUnderLogo ? 'mt-4' : '']"
    >
      <img
        v-if="showLogo"
        class="h-6"
        :class="[marginUnderLogo ? 'mb-6 mt-2 md:mb-8' : 'mb-6 md:mb-0']"
        src="@/assets/highway_logo.svg"
        alt="highway logo"
      />
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'HoldingTankLayoutWide',
  props: {
    showLogo: {
      type: Boolean,
      default: true,
    },
    marginUnderLogo: {
      type: Boolean,
      default: true,
    },
    customClass: {
      type: String,
      default: '',
    },
  },
};
</script>
